import { ArboProperty } from "../types"

export function discoverType(arbo: ArboProperty): { type: string; subtype: string } {
  const tipoImovel = arbo.tipo_imovel?.toLowerCase() || ""
  const categoria = arbo.categoria?.toLowerCase() || ""
  
  const typeMap: Record<string, { type: string; subtype: string }> = {
    "casa": { type: "Casa", subtype: "Casa padrão" },
    "casa térrea": { type: "Casa", subtype: "Casa padrão" },
    "sobrado": { type: "Casa", subtype: "Sobrado" },
    "apartamento": { type: "Apartamento", subtype: "Apartamento" },
    "cobertura": { type: "Apartamento", subtype: "Cobertura" },
    "duplex": { type: "Apartamento", subtype: "Duplex" },
    "triplex": { type: "Apartamento", subtype: "Triplex" },
    "kitnet": { type: "Apartamento", subtype: "Kitnet" },
    "studio": { type: "Apartamento", subtype: "Studio" },
    "flat": { type: "Apartamento", subtype: "Flat" },
    "loft": { type: "Apartamento", subtype: "Loft" },
    "terreno": { type: "Terreno/Lote", subtype: "Terreno" },
    "lote": { type: "Terreno/Lote", subtype: "Lote" },
    "chácara": { type: "Rural", subtype: "Chácara" },
    "sítio": { type: "Rural", subtype: "Sítio" },
    "fazenda": { type: "Rural", subtype: "Fazenda" },
    "sala comercial": { type: "Comercial", subtype: "Sala comercial" },
    "loja": { type: "Comercial", subtype: "Loja" },
    "galpão": { type: "Barracão/Armazém", subtype: "Barracão" },
    "barracão": { type: "Barracão/Armazém", subtype: "Barracão" },
    "armazém": { type: "Barracão/Armazém", subtype: "Armazém" },
    "prédio": { type: "Comercial", subtype: "Prédio comercial" },
    "ponto comercial": { type: "Comercial", subtype: "Ponto comercial" },
  }

  for (const [key, value] of Object.entries(typeMap)) {
    if (tipoImovel.includes(key) || categoria.includes(key)) {
      return value
    }
  }

  if (categoria.includes("comercial")) {
    return { type: "Comercial", subtype: "Imóvel comercial" }
  }

  if (categoria.includes("residencial")) {
    return { type: "Casa", subtype: "Casa padrão" }
  }

  return { type: "Outros", subtype: "Outros" }
}